import React, { useEffect, useState } from "react";
import { omitBy, isNil } from "lodash";

// SERVICES
import { fetchOrderSettingList } from "Services/order-setting.service";

// HELPERS
import { toaster } from "Helpers/toaster";
import { useSession } from "Hooks/index";

const AdditionalInsuranceContent = () => {
  const [minimumInsuranceThreshold, setMinimumInsuranceThreshold] = useState<any>(0);
  const { org } = useSession();

  const filters = {
    orgID: org._id,
    type: "INSURANCE",
  };

  useEffect(() => {
    handleFetchOrderSettingsList();
  }, []);

  const handleFetchOrderSettingsList = async () => {
    const responseData: any = await fetchOrderSettingList(omitBy(filters, isNil));
    if (responseData && !responseData.error) {
      setMinimumInsuranceThreshold(getMinimumInsuranceAmount(responseData));
    } else {
      toaster("error", responseData.error.message);
    }
  };

  const getMinimumInsuranceAmount = (data) => {
    const minimumValue = data[0].insuranceCharges[0].valueFrom;
    return minimumValue;
  };

  return (
    <div className="om-ocf-pi-insurance">
      Parcels with a value of up to RM{minimumInsuranceThreshold} are covered by the Diolko standard
      insurance. Any value above that threshold, requires additional insurance.
    </div>
  );
};

export default AdditionalInsuranceContent;
